import {
    buildSupabaseChainFilter,
    convertKeysToCamelCase,
    convertProgramSnakeToCamelCase,
    handlePageCountCommon,
} from 'utils/utilCommon'
import { supabase } from '../axios.instance'
import { getCountProgramCountRPC } from '../rpc/rpc.api'

const table = 'program_info' // 교육 정보
const matchingTable = 'program_instructor_matching' // 강사매칭

export const getProgramList = async (search, regionId, path) => {
    try {
        let filter = null
        let paginationInfo = null

        const pageSize = 10
        // query
        const { query } = await buildSupabaseChainFilter(table, search, regionId, path)

        const response = await query
        const searchParams = new URLSearchParams(search)
        const queryParams = new URLSearchParams(query.url.search)
        const params = Object.fromEntries(queryParams.entries())
        const newParams = {
            region_id: params.region_id,
            class_hours: params.class_hours,
            status: params.status,
            education_type: params.education_type,
            course: params.course,
            category: params.category,
            grade: params.grade,
            start_date: searchParams.get('startDate'),
            end_date: searchParams.get('endDate'),
        }

        // 메인페이지 분기처리 (필터카운트, 페이지 정보 필요 X)
        if (path !== 'main') {
            filter = await getCountProgramCountRPC(newParams)
            filter = convertKeysToCamelCase(filter)
            paginationInfo = handlePageCountCommon(search, response, pageSize)
        }

        // 현재 JSON 데이터 형태로 컨버팅
        if (response.data) {
            // 데이터 테이블 컨버팅 없이 반환
            if (path === 'data-table') {
                return response
            }
            const convertedData = response.data.map(convertProgramSnakeToCamelCase)

            if (path !== 'main') {
                response.data = {
                    filterCountInfo: filter,
                    programList: convertedData,
                    page: paginationInfo,
                }
            } else {
                response.data = {
                    programList: convertedData,
                }
            }
            return response
        }
        return response
    } catch (error) {
        console.error(error)
        return null
    }
}

export const getProgramById = async programId => {
    try {
        const response = await supabase
            .from(table)
            .select(`*,program_instructor_matching(*),program_attachment(*)`)
            .eq('program_id', programId)
            .eq('is_delete', false)
            .eq('program_instructor_matching.is_delete', false)
        if (response.data) {
            const convertedData = response.data.map(convertProgramSnakeToCamelCase)
            response.data = convertedData
        }
        return response.data[0]
    } catch (error) {
        console.error(error)
        return error
    }
}

/**
 * 가장 높은 교육 index값 가져오기
 * program_id
 * 사용안함
 * @param programId
 * @returns {Promise<*|null>}
 */
export const getMaxProgramId = async () => {
    try {
        const { data, error } = await supabase
            .from(table)
            .select('program_id')
            .order('program_id', { ascending: false })
            .limit(1)

        console.log('error : ', error)

        return data
    } catch (error) {
        console.error(error)
        return null
    }
}

export const postProgram = async programList => {
    try {
        const response = await supabase.from(table).insert(programList).select()
        return response
    } catch (error) {
        console.error(error)
        return null
    }
}

export const editProgram = async program => {
    try {
        const response = await supabase.from(table).update(program).eq('program_id', program.program_id)
        return response
    } catch (error) {
        console.error(error.message)
        return error
    }
}

/**
 * 수퍼베이스 삭제
 * is_delete(삭제여부) true 변경
 * @param programId
 * @returns {Promise<PostgrestResponseSuccess<GetResult<any, any, R | unknown, "*">[]>|PostgrestResponseFailure|null>}
 */
export const deleteProgramById = async programId => {
    try {
        const response = await supabase.from(table).update({ is_delete: true }).eq('program_id', programId).select()
        return response
    } catch (error) {
        console.error(error)
        return null
    }
}

/**
 * 강사매칭 정보 등록
 * @param programList
 * @returns {Promise<PostgrestResponseSuccess<GetResult<any, any, R | unknown, "*">[]>|PostgrestResponseFailure|null>}
 */
export const postProgramInstructorMatching = async matchingList => {
    try {
        const response = await supabase.from(matchingTable).upsert(matchingList).select()
        return response
    } catch (error) {
        console.error(error)
        return null
    }
}
// 교육 계획 관리 (주강사, 보조강사, 수료학생, 교육기간) 조회
export const getTutorCountsByProgramIds = async programIds => {
    try {
        const { data, error } = await supabase
            .from('program_instructor_matching')
            .select()
            .in('program_id', programIds)
            .eq('is_delete', false)

        if (error) throw error

        const counts = {}
        data.forEach(item => {
            const pid = item.program_id
            if (!counts[pid]) {
                counts[pid] = { mainTutor: 0, assistantTutor: 0 }
            }
            if (item.tutor_type === '주강사') counts[pid].mainTutor += 1
            if (item.tutor_type === '보조강사') counts[pid].assistantTutor += 1
        })

        return counts
    } catch (err) {
        console.error('튜터 카운트 가져오기 실패:', err)
        return {}
    }
}

// 강사 상세 프로그램 정보 조회
export const fetchProgramInfoTutor = async program_id => {
    try {
        const { data, error } = await supabase
            .from(table)
            .select(
                'program_name, organization_name, address_sido, address_bname, address_sigungu, start_date, end_date',
            )
            .eq('program_id', program_id)
            .single()

        if (error) throw error

        return data
    } catch (error) {
        console.log(error)
    }
    return null
}
// 프로그램 상세 조회
export const fetchProgramInfo = async programId => {
    return supabase.from(table).select().eq('program_id', programId)
}

// 강사 매칭 정보 조회
export const fetchProgramInstructorMatching = async programId => {
    return supabase.from(matchingTable).select().eq('program_id', programId).eq('is_delete', false)
}
// 프로그램 첨부파일 업서트
export const upsertProgramAttachment = async (attachments, programId) => {
    const filtered = attachments.map(({ id, instructor_matching_no, attachment_no, ...rest }) => ({
        ...rest,
        program_id: programId,
    }))

    return supabase.from('program_attachment').upsert(filtered)
}

// 프로그램 강사 매칭 업서트
export const upsertProgramInstructorMatching = async (matchings, programId, startDate, endDate) => {
    const filtered = matchings.map(({ id, instructor_matching_no, attachment_no, ...rest }) => ({
        ...rest,
        program_id: programId,
        start_date: startDate,
        end_date: endDate,
    }))

    return supabase.from('program_instructor_matching').upsert(filtered)
}
// 최종완료 상태값 변경
export const upsertComplete = async programId => {
    const { data, error } = await supabase.from(table).update({ is_completed: true }).eq('program_id', programId)

    if (error) {
        throw new Error(error.message)
    }
    console.log(data)
    return data
}

/**
 * 월별 교육 프로그램 요약 통계 조회 (chart 용)
 * @param month 1~12월 (숫자)
 */
export const getMonthlyProgramChart = async month => {
    try {
        const { data, error } = await supabase.rpc('get_month_total_program', {
            month_param: month,
        })

        if (error) {
            console.error('get_month_total_program 에러:', error.message)
            return []
        }

        return data ?? []
    } catch (error) {
        console.error('getMonthlyProgramChart 호출 실패:', error)
        return []
    }
}

export const getProgramHistory = async programId => {
    try {
        const { data, error } = await supabase.rpc('get_audit_log', {
            category_param: 'program',
            id_param: programId,
        })

        if (error) {
            console.error('getProgramHistory 호출 실패:', error)
            return { data: [], error }
        }

        return data
    } catch (error) {
        console.error('getProgramHistory 호출 실패:', error)
        return []
    }
}
